import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from '@tanstack/react-router';
import { Select, Space } from 'antd';
import { useActiveOrg } from '../active-org-context';

const CREATE = '__create__';

/** Header control to switch the active organization or create a new one. */
export function OrgSwitcher() {
  const navigate = useNavigate();
  const { organizations, activeOrgId, setActiveOrgId } = useActiveOrg();

  if (organizations.length === 0) return null;

  return (
    <Select<string>
      value={activeOrgId}
      style={{ minWidth: 200 }}
      onChange={(value) => {
        if (value === CREATE) void navigate({ to: '/organizations/new' });
        else setActiveOrgId(value);
      }}
      options={[
        {
          label: 'Organizations',
          options: organizations.map((o) => ({ label: o.name, value: o.id })),
        },
        {
          label: 'Actions',
          options: [
            {
              value: CREATE,
              label: (
                <Space>
                  <PlusOutlined />
                  New organization
                </Space>
              ),
            },
          ],
        },
      ]}
    />
  );
}
